import {useLayoutEffect} from 'react';
import {useAppearanceRecord} from './teamAppearanceStore';
import {generateTeamTheme} from './teamAppearanceModel';
import {brandThemeCss} from './brandTokens';

export default function TeamAppearanceRuntime({teamId,uid,database}) {
  const team=useAppearanceRecord('team',teamId,uid,database);
  const preference=useAppearanceRecord('user',uid,uid,database);
  useLayoutEffect(()=>{
    const root=document.documentElement;
    let style;
    const update=()=>{
      const mode=root.classList.contains('light')?'light':'dark';
      const theme=teamId && uid && !preference.value?.useValovate?generateTeamTheme(team.value,mode):null;
      if(!theme){style?.remove();style=null;root.removeAttribute('data-team-theme');return;}
      if(!style){style=document.createElement('style');style.id='valovate-team-appearance';document.head.appendChild(style);}
      style.textContent=brandThemeCss(theme,mode,':root[data-team-theme]:not([data-brand-preview])');
      root.setAttribute('data-team-theme',teamId);
    };
    update();
    const observer=new MutationObserver(update);observer.observe(root,{attributes:true,attributeFilter:['class']});
    return()=>{observer.disconnect();style?.remove();root.removeAttribute('data-team-theme');};
  },[teamId,uid,team.value,preference.value]);
  return null;
}
